import React from 'react'
import classnames from 'classnames'

import { ContainerSizes } from '../types'

type GridContainerProps = {
  containerSize?: ContainerSizes
}

export const GridContainer =({
  children,
  containerSize,
  className,
  ...props
}: GridContainerProps & React.HTMLAttributes<HTMLDivElement>): React.ReactElement =>{
  const classes = classnames(
    {
      'grid-container': !containerSize,
      [`grid-container-${containerSize}`]: !!containerSize,
    },
    className
  );

    return (
      <div
        data-testid="gridContainer"
        className={classes}
        {...props}>
        {children}
      </div>
    )
}